/**
 * Controls visibility of the AI chat sidebar "Raw stream" debug toggle.
 *
 * The toggle is a developer-only debug view, so it is **hidden by default**. It is shown **only**
 * when `REACT_APP_AI_CHAT_SHOW_RAW_STREAM` is explicitly set to `"true"` / `"1"` — a developer
 * escape hatch for local/debug builds. Any other value (including unset) hides it.
 */
export function resolveShowAiChatRawStreamToggle(): boolean {
  const override = process.env.REACT_APP_AI_CHAT_SHOW_RAW_STREAM?.trim().toLowerCase()
  return override === 'true' || override === '1'
}
